import get from 'get-object-path';
import { downloadFile } from '@/util/helpers';

export const importedFiles = {
    namespaced: true,

    state: {
        session: null,
        file: null,
        telemetryFile: null,
        files: [],
        lzmaFiles: [],
        downloadFileLoading: false,
        errors: {},
        filter: {
            pieces: [],
            crews: []
        }
    },

    getters: {
        filter(state) {
            return state.filter;
        },

        selectedChangeSportFile(state) {
            return state.file;
        },

        selectedChangeSportFiles(state) {
            return state.files;
        },

        selectedLzmaFiles(state) {
            return state.lzmaFiles;
        },

        downloadFileLoading(state) {
            return state.downloadFileLoading;
        },

        selectedChangeSportErrors(state) {
            return state.errors;
        },

        session(state) {
            return state.session;
        },

        seatRacing(state) {
            return state.session && state.session.seat_racing;
        },

        sportId(state) {
            return get(state.session, 'session.data.sport.id');
        },

        sessionFilesUsers(state) {
            return get(state.session, 'session_files.data.users.data') || [];
        },

        sessionFilesCrews(state) {
            return get(state.session, 'session_files.data.crews.data') || [];
        },

        pieces(state) {
            if (!state.session) {
                return [];
            }
            if (!get(state.session, 'session.data.structure.data[0].pieces.data')) {
                // old sessions with no pieces
                return [{ crews: { data: state.session.crews.data } }];
            }
            if (state.session.seat_racing || state.session.seat_racing === null) {
                return get(state.session, 'session.data.structure.data[0].pieces.data');
            }
            return [get(state.session, 'session.data.structure.data[0].pieces.data[0]')].filter(Boolean);
        },

        crews(state, getters) {
            const crews = [];
            getters.pieces.forEach((piece, pieceIndex) => {
                const pieceCrews = get(piece, 'crews.data') || [];
                pieceCrews.forEach(crew => {
                    let sessionFilesCrew = getters.sessionFilesCrews.find(({ id }) => id === crew.id) || {};
                    if (_.isEmpty(sessionFilesCrew) && !state.session.seat_racing) {
                        sessionFilesCrew = getters.sessionFilesCrews.find(({ id }) => id === crew.parent_id) || {};
                    }
                    const crewFile = get(sessionFilesCrew, 'session_crew_files.data') || null;
                    const telemetryFile = get(sessionFilesCrew, 'telemetry_files.data') || null;
                    const crewUsers = (get(crew, 'crew_users.data') || []).map(user => {
                        const sessionFilesUser = getters.sessionFilesUsers.find(({ id }) => id === user.user_id) || {};
                        const file = get(sessionFilesUser, 'session_individual_files.data') || null;
                        if (file) {
                            return {
                                ...file,
                                user: get(user, 'user.data')
                            };
                        }
                    });

                    crews.push({
                        id: crew.id,
                        name: crew.name,
                        parent_id: crew.parent_id,
                        piece_id: piece.id,
                        piece_index: pieceIndex,
                        crewFile: crewFile ? { ...crewFile, user: get(crewFile, 'user.data') } : null,
                        telemetryFile: telemetryFile ? { ...telemetryFile } : null,
                        crewUsers: _.sortBy(crewUsers, 'user.full_name').filter(Boolean)
                    });
                });
            });
            return _.sortBy(crews, ({ name }) => name && name.toLowerCase());
        }
    },

    mutations: {
        resetFilter(state) {
            state.filter = {
                pieces: [],
                crews: []
            };
        },

        resetFilterPieces(state) {
            state.filter.pieces = [];
        },

        resetFilterCrews(state) {
            state.filter.crews = [];
        },

        resetSession(state) {
            state.session = null;
        },

        setSession(state, session) {
            state.session = session;
        },

        setChangeSportModalFile(state, file) {
            state.file = file;
        },

        selectFile(state, payload) {
            const index = state.files.indexOf(payload.fileId);
            if (payload.event && index === -1) {
                state.files.push(payload.fileId);
            } else if (!payload.event && index !== -1) {
                state.files.splice(index, 1);
            }
        },

        selectLzmaFile(state, payload) {
            const index = state.lzmaFiles.indexOf(({ fileId }) => fileId === payload.file.id);
            if (payload.event && index === -1) {
                state.lzmaFiles.push(payload.file);
            } else if (!payload.event && index !== -1) {
                state.lzmaFiles.splice(index, 1);
            }
        },

        resetFiles(state) {
            state.files = [];
        },

        resetLzmaFiles(state) {
            state.lzmaFiles = [];
        },

        setError(state, payload) {
            Vue.set(state.errors, payload.fileId, payload.message);
        },

        resetErrors(state) {
            state.errors = {};
        },

        updateDownloadFilesLoading(state, value = true) {
            state.downloadFileLoading = value;
        }
    },

    actions: {
        downloadXls({ commit, dispatch }, data) {
            commit('updateDownloadFilesLoading', true);
            return dispatch(
                'post',
                {
                    url: `${api}crews/export-event-to-xls`,
                    data
                },
                { root: true }
            )
                .then(({ data: { file_url, filename } }) => {
                    return downloadFile(file_url, filename);
                })
                .catch(error => {
                    return dispatch('notifyError', error, { root: true });
                })
                .finally(() => {
                    return commit('updateDownloadFilesLoading', false);
                });
        }
    }
};

export default importedFiles;
